import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c8901ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkout" }
const _hoisted_2 = { class: "display-2 center" }
const _hoisted_3 = {
  key: 0,
  class: "layout gutter--lg"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "center mb-2" }, "Sprog / Language", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Dansk")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("English")
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "flex md6" }
const _hoisted_9 = { class: "informationBox mb-5" }
const _hoisted_10 = { class: "display-4 center mb-2" }
const _hoisted_11 = {
  key: 0,
  class: "row justify--center"
}
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "row checkOutField" }
const _hoisted_16 = { class: "md12 xs12 flex" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "flex xs12 md12" }
const _hoisted_19 = { class: "row justify--center" }
const _hoisted_20 = { class: "flex md4 xs8" }
const _hoisted_21 = { class: "flex md3 xs6" }
const _hoisted_22 = { class: "flex md5 xs6" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "flex md4 xs4" }
const _hoisted_25 = { class: "flex md8 xs8" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "flex md12 xs12" }
const _hoisted_28 = {
  key: 0,
  class: "row"
}
const _hoisted_29 = { class: "flex md12 xs12" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "flex md12 xs12" }
const _hoisted_32 = { class: "flex md6 xs12" }
const _hoisted_33 = { class: "productBox mb-4" }
const _hoisted_34 = { class: "display-4 center" }
const _hoisted_35 = {
  key: 0,
  class: "editCart"
}
const _hoisted_36 = { class: "row justify--center align--center" }
const _hoisted_37 = { class: "flex center" }
const _hoisted_38 = {
  key: 0,
  class: "row justify--center align--center"
}
const _hoisted_39 = { class: "flex center" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Brugt af klubsaldoen")
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", null, [
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1))
const _hoisted_42 = { class: "row justify--space-between" }
const _hoisted_43 = { class: "flex" }
const _hoisted_44 = { class: "largerFont" }
const _hoisted_45 = { class: "flex" }
const _hoisted_46 = { class: "row justify--center" }
const _hoisted_47 = { class: "flex" }
const _hoisted_48 = { class: "checkout" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_53 = {
  target: "_blank",
  action: "https://ssl.ditonlinebetalingssystem.dk/integration/ewindow/Default.aspx",
  method: "get"
}
const _hoisted_54 = ["value"]
const _hoisted_55 = ["value"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  hidden: "",
  name: "currency",
  value: "DKK"
}, null, -1))
const _hoisted_57 = ["value"]
const _hoisted_58 = /*#__PURE__*/_createStaticVNode("<input hidden name=\"language\" value=\"1\" data-v-6c8901ec><input hidden name=\"instantcapture\" value=\"1\" data-v-6c8901ec><input hidden name=\"ownreceipt\" value=\"0\" data-v-6c8901ec><input hidden name=\"ordertext\" value=\"DDU\" data-v-6c8901ec><input hidden name=\"timeout\" value=\"15\" data-v-6c8901ec><input hidden name=\"accepturl\" value=\"https://frontend.dart-ddu.dk/eksternservicepgaccepts\" data-v-6c8901ec><input hidden name=\"cancelurl\" value=\"https://frontend.dart-ddu.dk/eksternservicepgcancels\" data-v-6c8901ec><input hidden name=\"callbackurl\" value=\"https://frontend.dart-ddu.dk/eksternservicepgcallbacks\" data-v-6c8901ec><input hidden name=\"windowstate\" value=\"3\" data-v-6c8901ec><input hidden name=\"instantcallback\" value=\"1\" data-v-6c8901ec><input hidden name=\"cms\" value=\"DDU VUE3 app / Strapi v3\" data-v-6c8901ec>", 11)
const _hoisted_69 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_button_group = _resolveComponent("va-button-group")!
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_form = _resolveComponent("va-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_va_divider = _resolveComponent("va-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.languageValue === 1 ? 'Kassen' : 'Checkout'), 1),
      (!_ctx.submitted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_va_button_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  size: "small",
                  color: (_ctx.languageValue === 1 ? '#ab0033' : 'primary'),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.languageValue = 1))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["color"]),
                _createVNode(_component_va_button, {
                  size: "small",
                  color: (_ctx.languageValue === 2 ? '#ab0033' : 'primary'),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.languageValue = 2))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.languageValue === 1 ? 'Mine oplysninger' : 'My informations'), 1),
                  (_ctx.canMakeClubPurchase)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_va_checkbox, {
                            label: "Klubkøb",
                            modelValue: _ctx.clubPurchase,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.clubPurchase) = $event)),
                            bordered: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_13, [
                          _createElementVNode("p", null, _toDisplayString('Klubsaldo for ' + _ctx.clubPurchaseInfo.name + ': ' + _ctx.clubPurchaseInfo.clubCredits), 1)
                        ], 512), [
                          [_vShow, _ctx.clubPurchase]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_va_input, {
                            modelValue: _ctx.clubPurchaseInfo.useOfCredits,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.clubPurchaseInfo.useOfCredits) = $event)),
                            type: "number",
                            label: "Bruge beløb af klubsaldo",
                            rules: [(v) => Number(v) <= _ctx.clubPurchaseInfo.clubCredits || 'Ikke nok på klubsaldoen'],
                            bordered: ""
                          }, null, 8, ["modelValue", "rules"])
                        ], 512), [
                          [_vShow, _ctx.clubPurchase]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_va_form, {
                    ref: "form",
                    id: "checkout-form"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_va_input, {
                            bordered: "",
                            type: "text",
                            modelValue: _ctx.orderData.name,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.orderData.name) = $event)),
                            label: _ctx.languageValue === 1 ? 'Navn' : 'Name',
                            style: {"width":"100%"}
                          }, null, 8, ["modelValue", "label"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_va_input, {
                            bordered: "",
                            class: "checkOutField",
                            type: "text",
                            modelValue: _ctx.orderData.address,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.orderData.address) = $event)),
                            label: _ctx.languageValue === 1 ? 'Adresse' : 'Address'
                          }, null, 8, ["modelValue", "label"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_va_select, {
                            bordered: "",
                            searchable: "",
                            label: _ctx.languageValue === 1 ? 'Land' : 'Country',
                            options: _ctx.countryListOptions,
                            modelValue: _ctx.countryStringValue,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.countryStringValue) = $event))
                          }, null, 8, ["label", "options", "modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_va_input, {
                            bordered: "",
                            type: "text",
                            modelValue: _ctx.orderData.zipCode,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.orderData.zipCode) = $event)),
                            label: _ctx.languageValue === 1 ? 'Postnr' : 'Zipcode',
                            onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.cityZipCodeInputFocus = 2))
                          }, null, 8, ["modelValue", "label"])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_va_input, {
                            bordered: "",
                            type: "text",
                            label: _ctx.languageValue === 1 ? 'By' : 'Town',
                            modelValue: _ctx.orderData.city,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.orderData.city) = $event)),
                            onFocus: _cache[10] || (_cache[10] = ($event: any) => (_ctx.cityZipCodeInputFocus = 1))
                          }, null, 8, ["label", "modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_va_input, {
                            bordered: "",
                            type: "text",
                            label: _ctx.languageValue === 1 ? 'Landekode' : 'Country Code',
                            modelValue: _ctx.phoneCode,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.phoneCode) = $event)),
                            readonly: ""
                          }, null, 8, ["label", "modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_va_input, {
                            bordered: "",
                            type: "text",
                            modelValue: _ctx.orderData.telephone,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.orderData.telephone) = $event)),
                            label: _ctx.languageValue === 1 ? 'Telefon' : 'Phone'
                          }, null, 8, ["modelValue", "label"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_va_input, {
                            class: "checkOutField",
                            bordered: "",
                            type: "email",
                            modelValue: _ctx.orderData.email,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.orderData.email) = $event)),
                            label: "Email"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      (_ctx.clubPurchase)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_component_va_input, {
                                bordered: "",
                                type: "text",
                                modelValue: _ctx.orderData.club,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.orderData.club) = $event)),
                                label: "Klub"
                              }, null, 8, ["modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_va_input, {
                            class: "checkOutField",
                            type: "textarea",
                            modelValue: _ctx.orderData.comment,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.orderData.comment) = $event)),
                            label: _ctx.languageValue === 1 ? 'evt. kommentar' : 'Message to order'
                          }, null, 8, ["modelValue", "label"])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 512)
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("h4", _hoisted_34, [
                    _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Produkter i kurven ' : 'Products in cart'), 1),
                    (!_ctx.$route.query)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                          _createElementVNode("i", null, [
                            _createVNode(_component_router_link, { to: "/kurven" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? '(rediger))' : '(edit))'), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartItems, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item.placeInCart
                    }, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("p", null, [
                            _createElementVNode("strong", null, _toDisplayString(item.productName), 1)
                          ]),
                          _createElementVNode("p", null, [
                            _createElementVNode("i", null, _toDisplayString(item.productDescription), 1)
                          ]),
                          _createElementVNode("p", null, _toDisplayString(item.quantity + ' x ' + item.price + ' kr.'), 1)
                        ])
                      ]),
                      _createVNode(_component_va_divider)
                    ], 64))
                  }), 128)),
                  (_ctx.clubPurchase && _ctx.clubPurchaseInfo.useOfCredits > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _hoisted_41,
                          _createElementVNode("p", null, _toDisplayString('-' + _ctx.clubPurchaseInfo.useOfCredits + ' kr.'), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("p", _hoisted_44, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.languageValue === 1 ? 'Beløb i alt:' : 'Total amount:'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.calcTotal()) + " kr.", 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_va_button, {
                  size: "large",
                  rounded: false,
                  color: "success",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.createNewOrder()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Køb nu' : 'Order now'), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !(_ctx.bamboraModal && _ctx.bamboraSession !== null)]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_48, [
      _createElementVNode("p", null, [
        _createElementVNode("b", null, _toDisplayString(_ctx.languageValue === 1 ? 'Ordre ID: ' : 'Order ID: ') + " " + _toDisplayString(_ctx.currentOrderid.toString()), 1),
        _hoisted_49,
        _createElementVNode("b", null, _toDisplayString(_ctx.languageValue === 1 ? 'Beløb: ' : 'Amount: ') + " " + _toDisplayString(this.calcTotal()) + " DKK", 1),
        _hoisted_50,
        _hoisted_51
      ]),
      _hoisted_52,
      _createElementVNode("form", _hoisted_53, [
        _createElementVNode("input", {
          hidden: "",
          name: "merchantnumber",
          value: _ctx.mercNbr
        }, null, 8, _hoisted_54),
        _createElementVNode("input", {
          hidden: "",
          name: "amount",
          value: (this.calcTotal() * 100).toString()
        }, null, 8, _hoisted_55),
        _hoisted_56,
        _createElementVNode("input", {
          hidden: "",
          name: "orderid",
          value: _ctx.currentOrderid.toString()
        }, null, 8, _hoisted_57),
        _hoisted_58,
        _createElementVNode("input", {
          type: "submit",
          value: (_ctx.languageValue === 1 ? 'Betal nu' : 'Pay now')
        }, null, 8, _hoisted_69)
      ])
    ], 512), [
      [_vShow, (_ctx.bamboraModal && _ctx.bamboraSession !== null)]
    ])
  ]))
}